<template>
  <div class="countdown-timer">
    {{ countdown }}
  </div>
</template>

<script>
export default {
  name: 'CountdownTimer',
  props: {
    countdown: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style scoped>
.countdown-timer {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.5rem;
  color: #ff0000;
  font-weight: bold;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px 16px;
  border-radius: 20px;
  border: 2px solid #ff0000;
  animation: pulse-countdown 1s infinite;
}

@keyframes pulse-countdown {
  0% { transform: translateX(-50%) scale(1); }
  50% { transform: translateX(-50%) scale(1.1); }
  100% { transform: translateX(-50%) scale(1); }
}
</style>
